<template>
    <div class="guarantee-rate">
        <MyTitle theTitle="查看评价"/>
        <van-cell-group class="fd-com-scroll">
            <van-cell>
                <van-row>
                    <van-col span="5" class="col-key" align="left">担保速度</van-col>
                    <van-col span="18" class="col-value" offset="1">
                        <van-rate v-model="formData.nDbsdn" readonly></van-rate>
                        <span class="rate-num">{{formData.nDbsdn * 2}}分</span>
                    </van-col>
                </van-row>
            </van-cell>
            <van-cell>
                <van-row>
                    <van-col span="5" class="col-key" align="left">服务水平</van-col>
                    <van-col span="18" class="col-value" offset="1">
                        <van-rate v-model="formData.nFwspn" readonly></van-rate>
                        <span class="rate-num">{{formData.nFwspn * 2}}分</span>
                    </van-col>
                </van-row>
            </van-cell>
            <van-cell>
                <van-row>
                    <van-col span="5" class="col-key" align="left">理赔服务</van-col>
                    <van-col span="18" class="col-value" offset="1">
                        <van-rate v-model="formData.nLpfwn" readonly></van-rate>
                        <span class="rate-num">{{formData.nLpfwn * 2}}分</span>
                    </van-col>
                </van-row>
            </van-cell>
            <van-field
                    clearable
                    disabled
                    label="评价"
            ></van-field>
            <textarea rows="3"
                      class="evaluate-content"
                      readonly v-model="formData.cYjjy"
                      cols="24"></textarea>
        </van-cell-group>

        <div class="fd-com-btn-container">
            <van-button
                type="info"
                round
                plain
                @click="goToMyGuarantee">
                关闭
            </van-button>
        </div>
    </div>
</template>

<script>
    import MyTitle from '../../components/common/myTitle'
    import Vue from 'vue';
    import {Rate,Dialog,Notify} from 'vant';
    import {
        cYjjyRule,
        nDbsdnRule,
        nFwspnRule,
        nLpfwnRule
    } from '@/utils/validator/rules';
    Vue.use(Rate);
    export default {
        components: {
            MyTitle,
        },
        data() {
            return {
                formData: {
                    cYjjy: '', // 意见建议
                    nDbsdn: 0, // 担保速度
                    nFwspn: 0, // 服务水平
                    nLpfwn: 0, // 理赔服务
                },
                radio: '1',
                fieldSize: {
                    maxHeight: 80,
                    minHeight: 80
                }
            }
        },
        methods: {
            goToMyGuarantee: function () {
                this.$router.push("/home/myGuarantee");
            },
            init(){
                let cId = sessionStorage.getItem('currentDbid')
                this.$axios.get("ssbq/api/ssdb/dbpj?dbid="+cId).then(res=>{
                    console.log(res);
                    this.formData.cYjjy = res.data.cYjjy
                    this.formData.nDbsdn = res.data.nDbsd/2
                    this.formData.nFwspn = res.data.nFwsp/2
                    this.formData.nLpfwn = res.data.nLpfw/2
                })
            }
        },
        created(){
            this.init()
        }
    }
</script>

<style lang="less" scoped>
    .rate-radio-group {
        display: flex;
        float: left;
    }

    .color-text{
        color: red;
    }

    .guarantee-rate {
        overflow-y: scroll;
        height: 100%;
    }

    .evaluate-content {
        margin-bottom: 2vh;
        height: 25vh !important;
    }

    .rate-num{
        padding-left: 0.5rem;
    }
    .evaluate-content {
        width:98%;
        height: auto;
        font-size:16px;
        color:#333;
        line-height:24px;
        padding-left:20px;
    }
</style>
